import api from "./api";

const getCountryAPI = (data: { language: string[] }) => {
  return api.post("/country/", data);
};

export default getCountryAPI;
